import React from 'react';
export type Option = {
  value: string;
  label: string;
  hint?: string;
};
type OptionGroupProps = {
  label: string;
  options: Option[];
  value: string | null;
  onChange: (value: string) => void;
  columns?: 'wide' | 'compact';
};
export function OptionGroup({
  label,
  options,
  value,
  onChange,
  columns = 'wide'
}: OptionGroupProps) {
  const grid = columns === 'wide' ? 'sm:grid-cols-2 lg:grid-cols-3' : 'grid-cols-2 sm:grid-cols-3 lg:grid-cols-6';
  return <div role="radiogroup" aria-label={label} className={`grid gap-3 ${grid}`} data-id="element-189" data-mp="3j25k45cgwpz8">
      {options.map(o => {
      const selected = value === o.value;
      return <button key={o.value} type="button" role="radio" aria-checked={selected} onClick={() => onChange(o.value)} className={`flex min-h-[76px] flex-col items-start justify-center rounded-xl border px-5 py-4 text-left transition-[border-color,box-shadow,background-color] duration-150 ease-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent ${selected ? 'border-accent bg-white shadow-[0_0_0_1px_#2448c4]' : 'border-rule bg-white hover:border-ink/40'}`} data-id="element-190" data-mp="3a8ismrfam8vu">
            <span className="flex w-full items-center justify-between gap-3" data-id="element-191" data-mp="3kn6lc3oui8b">
              <span className="whitespace-nowrap font-serif text-xl text-ink" data-id="element-192" data-mp="rbafo0pcbdwg">{o.label}</span>
              <span className={`h-3.5 w-3.5 shrink-0 rounded-full border ${selected ? 'border-accent bg-accent' : 'border-ink/30'}`} aria-hidden="true" data-id="element-193" data-mp="wa3srs0pt2w3" />
            </span>
            {o.hint && <span className="mt-1 text-xs text-graphite" data-id="element-194" data-mp="mb4vf5legtoe">{o.hint}</span>}
          </button>;
    })}
    </div>;
}